import { useEffect, useState } from 'react'

import { FilledYellow, StrokeBlue } from 'css/Buttons'
import { showLoading } from 'services/util'

import { downloadBrochure, downloadEiarReport, getEiarReportExists } from '../nonauthdocumentsapi'
import { ReportsContainer, ReportsBlock, ReportsListing, RowWrapper, ReportLink, EndowmentSurvey, YearHeader } from '../ReportStyles'

function NonAuthEiarReports({ reportYear, publicId }) {
  const [reportExists, setReportExists] = useState()
  const [crmId, setCrmId] = useState()

  useEffect(() => {
    async function checkForReport() {
      setReportExists(undefined)
      setCrmId(undefined)
      showLoading(true)

      try {
        const response = await getEiarReportExists(reportYear, publicId)
        setReportExists(response && response.success === true)
        setCrmId(response && response.success === true ? response.crmId : undefined)
      }
      catch (error) {
        setReportExists(false)
        setCrmId(undefined)
      }
      finally {
        showLoading(false)
      }
    }

    checkForReport()
  }, [reportYear, publicId])

  const handleDownloadEiarReport = async () => {
    showLoading(true)

    try {
      await downloadEiarReport(reportYear, publicId)
    }
    finally {
      showLoading(false)
    }
  }

  if (reportExists === undefined) return null

  if (!reportExists) {
    return (
      <ReportsContainer>
        <ReportsBlock>
          <h3 className="h3">Endowment in Action Report</h3>
          <p>The requested report is not available.</p>
        </ReportsBlock>
      </ReportsContainer>
    )
  }

  return (
    <ReportsContainer>
      <ReportsBlock>
        <h3 className="h3">Endowment in Action Report</h3>
        <p>You can view your Endowment in Action report by clicking on the "Download" button in the section below.</p>
        <p>In addition to information about the performance of the university’s endowment, this report includes details about what you have made possible through your giving to individual endowed funds.</p>
        <p>Thank you for your support of UCLA!</p>

        <ReportsListing>
          <YearHeader>Fiscal Year {reportYear}</YearHeader>

          <RowWrapper className="reports-row-wrapper">
            <ReportLink>
              Endowment In Action Booklet - {reportYear}
              <FilledYellow onClick={() => downloadBrochure('EIAR', reportYear, crmId)}>Download</FilledYellow>
            </ReportLink>
          </RowWrapper>

          <RowWrapper className="reports-row-wrapper">
            <ReportLink>
              Endowment in Action Report - {reportYear}
              <FilledYellow onClick={handleDownloadEiarReport}>Download</FilledYellow>
            </ReportLink>
          </RowWrapper>
        </ReportsListing>

        <EndowmentSurvey>
          <p>How are we doing? Please take our survey and let us know what you think!</p>
          <StrokeBlue onClick={e => window.open('https://survey.sjc1.qualtrics.com/jfe/form/SV_cZ3tgdJNtnji99z?id_number=[[' + crmId + ']]')}>ENDOWMENT IN ACTION FEEDBACK SURVEY</StrokeBlue>
        </EndowmentSurvey>
      </ReportsBlock>
    </ReportsContainer>
  )
}

export default NonAuthEiarReports
